"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ListContextProvider: function() {
        return ListContextProvider;
    },
    listContextDefaultValue: function() {
        return listContextDefaultValue;
    },
    useListContext_unstable: function() {
        return useListContext_unstable;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const listContextDefaultValue = {
    navigationMode: undefined,
    selection: undefined,
    listItemRole: 'listitem',
    validateListItem: ()=>{
    /* noop */ }
};
const listContext = (0, _reactcontextselector.createContext)(undefined);
const ListContextProvider = listContext.Provider;
const useListContext_unstable = (selector)=>(0, _reactcontextselector.useContextSelector)(listContext, (ctx = listContextDefaultValue)=>selector(ctx));
